import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { createQueryParams } from '../../utils/query-params.service';

@Injectable({
  providedIn: 'root',
})
export class BlogTagsService {
  private http = inject(HttpClient);

  constructor() {}

  getBlogsByTagSlug(slug: string, limit = 6, page = 1): Observable<any> {
    const params = createQueryParams({
      searchKey: slug,
      limit,
      page,
    });
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/stories/blogs-tag/search?${params}`
    );
  }
}
